import CaptainAssistantAPI from 'dashboard/api/captain/assistant';
import { createStore } from '../storeFactory';
import { throwErrorMessage } from '../utils/api';

const mergeAssistantRecord = (current, next) => {
  if (!next) return current;
  if (!current) return next;

  const rawAvatarUrl =
    next.avatar_url ||
    next.avatarUrl ||
    next.thumbnail ||
    current.avatar_url ||
    current.avatarUrl ||
    current.thumbnail;

  const avatarUrl =
    rawAvatarUrl && !rawAvatarUrl.startsWith('blob:')
      ? `${rawAvatarUrl}${rawAvatarUrl.includes('?') ? '&' : '?'}v=${next.updated_at || Date.now()}`
      : rawAvatarUrl;

  return {
    ...current,
    ...next,
    avatar_url: avatarUrl,
    avatarUrl,
    thumbnail: avatarUrl,
  };
};

export default createStore({
  name: 'CaptainAssistant',
  API: CaptainAssistantAPI,
  actions: mutationTypes => ({
    update: async ({ commit, state }, payload) => {
      const { id, avatar, ...updateObj } = payload;
      commit(mutationTypes.SET_UI_FLAG, { updatingItem: true });

      try {
        const currentRecord = state.records.find(
          record => record.id === Number(id)
        );
        let latestRecord = currentRecord;

        if (avatar) {
          const avatarResponse = await CaptainAssistantAPI.uploadAvatar(
            id,
            avatar
          );
          latestRecord = mergeAssistantRecord(
            latestRecord,
            avatarResponse.data
          );
          commit(mutationTypes.EDIT, latestRecord);
        }

        if (Object.keys(updateObj).length > 0) {
          const response = await CaptainAssistantAPI.update(id, updateObj);
          latestRecord = mergeAssistantRecord(latestRecord, response.data);
          commit(mutationTypes.EDIT, latestRecord);
        }

        const refreshed = await CaptainAssistantAPI.show(id);
        latestRecord = mergeAssistantRecord(
          latestRecord,
          refreshed.data
        );
        commit(mutationTypes.EDIT, latestRecord);

        return latestRecord;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(mutationTypes.SET_UI_FLAG, { updatingItem: false });
      }
    },
    deleteAvatar: async ({ commit }, id) => {
      commit(mutationTypes.SET_UI_FLAG, { updatingItem: true });

      try {
        const response = await CaptainAssistantAPI.deleteAvatar(id);
        commit(mutationTypes.EDIT, response.data);
        return response.data;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(mutationTypes.SET_UI_FLAG, { updatingItem: false });
      }
    },
  }),
});
